import { render } from "./HumorElement.vue?vue&type=template&id=3954a722&scoped=true"
import script from "./HumorElement.vue?vue&type=script&lang=js"
export * from "./HumorElement.vue?vue&type=script&lang=js"

import "./HumorElement.vue?vue&type=style&index=0&id=3954a722&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3954a722"]])

export default __exports__